/**
 * Composable for bulk edit functionality
 */
import { ref } from "vue";
export function useBulkEdit({ period }) {
    const formData = ref({
        delegation: null,
        objectiveId: null,
        delegacionZonaDeVentas: "",
        columns: [],
        justification: "",
    });
    // Validate line count for a column
    const validateColumnLineCount = (value, expectedCount) => {
        if (!value.trim())
            return true; // Empty is valid (field not being edited)
        const lines = value.split("\n").filter((line) => line.trim() !== "");
        return lines.length === expectedCount;
    };
    // Parse textarea value into array of values
    const parseTextareaValue = (value) => {
        return value
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line !== "");
    };
    // Get line count from textarea value
    const getLineCount = (value) => {
        if (!value.trim())
            return 0;
        return value.split("\n").filter((line) => line.trim() !== "").length;
    };
    // Validate all columns
    const validateColumns = (delegacionValue, columns, expectedCount) => {
        // Delegacion is required
        const delegacionValid = validateColumnLineCount(delegacionValue, expectedCount);
        if (!delegacionValid || !delegacionValue.trim())
            return false;
        // All columns with values must have correct line count
        return columns.every((col) => validateColumnLineCount(col.value, expectedCount));
    };
    return {
        formData,
        validateColumnLineCount,
        parseTextareaValue,
        getLineCount,
        validateColumns,
    };
}
